module.exports = __webpack_public_path__ + "img/pattern.57d30f4a.png";